export const getConfigUI = (allParameters: any, settingUIState: any) => {

    let arrayUISetting: string[] = getIdUISetting(settingUIState);

    function getIdUISetting(settingUIState: any) {
        let arrayUISetting: string[] = [];

        settingUIState.forEach((section: any) => {
            section['setting'].forEach((settingUI: any) => getId(settingUI))
        })

        function getId(settingUI: any) {
            if (settingUI['data']['embeddedView']) {
                settingUI['data']['embeddedView'].forEach((settingUI: any) => {
                    if (settingUI['data']['typeOptions'] === 'configurationOptions') {
                        arrayUISetting.push(settingUI['data']['id']);
                    }
                    getId(settingUI)
                })
            } else {
                if (settingUI['data']['typeOptions'] === 'configurationOptions') {
                    arrayUISetting.push(settingUI['data']['id']);
                }
            }
        }

        return arrayUISetting;
    }

    let collectUiSettings: any = getCollectUIParameters(allParameters, arrayUISetting);
    // debugger
    function getCollectUIParameters(allParameters: any, arrayUISetting: any) {
        let uiSettings: any = {};
        allParameters.forEach((parameter: any) => {

            let nameParameter: string = parameter["variableName"];

            if (arrayUISetting.includes(nameParameter)) {
                uiSettings = {
                    ...uiSettings,
                    [nameParameter]: parameter
                }
            }
        })
        return uiSettings
    }



    settingUIState.forEach((section: any) => {
        section['setting'].forEach((settingState: any) => {
            settingState = UpdateSetting(settingState, collectUiSettings)
        })
    })


    function UpdateSetting(settingState: any, collectUiSettings: any) {
        let parameterUIId = settingState['data']['id'];
        let embeddedView = settingState['data']['embeddedView'];

        if (embeddedView) {
            embeddedView.map((settingUI: any) => {
                if (collectUiSettings[parameterUIId]) {
                    settingState = separationSetting(settingUI, collectUiSettings, parameterUIId)
                } else {
                    UpdateSetting(settingUI, collectUiSettings)
                }
            })
        } else {
            if (collectUiSettings[parameterUIId]) {
                settingState = separationSetting(settingState, collectUiSettings, parameterUIId)
            }
            return settingState
        }

        function separationSetting(settingUI: any, uiSettings: any, parameterUIId: any) {
            let type: any;

            if (['coDbaZip'].includes(parameterUIId)) {
                type = settingUI['type']
            } else if (['purchaseOption'].includes(parameterUIId)) {
                type = settingUI['type']
            }


            switch (type) {
                case 'LineParamInput':
                    settingUI['data']['values'] = uiSettings[parameterUIId]['value']
                    break;
                case 'LineParamRadio':

                    settingUI['data']['values'] = uiSettings[parameterUIId]['optionSet']['options']
                    break;

                default:
                    break;
            }

            return settingUI;
        }
    }

    return settingUIState;
}